import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import helpersNumbers from "../../../helpers/numbers";
import validationsFormsFinanceCharge from "../../../validtions/forms/finance/charge";
import TitleBar from "../../partials/content/TitleBar";
import ButtonDisable from "../../partials/other/ButtonDisable";

function Charge() {
  const [amount, setAmount] = useState(1000000);

  const calculateFinalAmount = (number) => {
    return Math.floor(
      number +
        (number * parseInt(process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE)) /
          100
    );
  };
  const [finalAmount, setFinalAmount] = useState(calculateFinalAmount(amount));
  const [finalAmountText, setFinalAmountText] = useState(
    helpersNumbers.generateTextPrice(finalAmount)
  );
  const [message, setMessage] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const changeAmount = (number) => {
    setAmount(number);
    setFinalAmount(calculateFinalAmount(number));
    setFinalAmountText(
      helpersNumbers.generateTextPrice(calculateFinalAmount(number))
    );
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setMessage();

    if (validationsFormsFinanceCharge(number) != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: validationsFormsFinanceCharge(number),
        class_icon: "fa fa-exclamation-triangle",
      });
    }
    changeAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="charge-finance" />

      <div className="content-wrapper">
        <TitleBar title="افزایش اعتبار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="container">
                <div className="alert alert-warning ">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        در این بخش شما میتوانید با پرداخت مبلغ مورد نظر موجودی
                        حساب کاربری خود را افزایش دهید. .
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        حداقل مبلغ ممکن جهت افزایش موجود حساب کاربری{" "}
                        <span className="number-finance">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              process.env.REACT_APP_AT_LEAST_AMOUNT_CHARGE
                            )
                          )}{" "}
                        </span>
                        تومان میباشد.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="row justify-content-center">
                  <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    {messageTag}
                    <div>
                      <div className="pb-2">مبلغ شارژ حساب (تومان)</div>
                      <div>
                        <div class="input-group">
                          <input
                            type="text"
                            id="amount"
                            class="form-control number-finance"
                            value={helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(amount)
                            )}
                            onChange={inputAmountChangeHandler}
                            onBeforeInput={inputAmountBeforeInputHandler}
                            dir="ltr"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">تومان</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex flex-column flex-sm-row align-sm-items-center  py-3">
                      <div className="pb-2 pb-md-0 pl-md-2 d-flex align-items-center">
                        مبالغ پیشنهادی:
                      </div>
                      <div className="d-flex flex-column align-items-center flex-lg-row flex-lg-grow-1 justify-content-lg-between ">
                        <div className="py-1 py-lg-0">
                          <button
                            className="btn btn-success number-finance"
                            onClick={() => {
                              changeAmount(1000000);
                            }}
                          >
                            ۱,۰۰۰,۰۰۰
                          </button>
                        </div>
                        <div className="py-1 py-lg-0">
                          <button
                            className="btn btn-success number-finance"
                            onClick={() => {
                              changeAmount(5000000);
                            }}
                          >
                            ۵,۰۰۰,۰۰۰
                          </button>
                        </div>
                        <div className="py-1 py-lg-0">
                          <button
                            className="btn btn-success number-finance"
                            onClick={() => {
                              changeAmount(10000000);
                            }}
                          >
                            ۱۰,۰۰۰,۰۰۰
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="border border-1 rounded">
                      <div className="d-flex flex-column align-items-center justify-content-between flex-lg-row border-bottom p-3">
                        <span>مبلغ</span>
                        <span>
                          <span className="number-finance pl-2">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(amount)
                            )}
                          </span>
                          <span>تومان</span>
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center justify-content-between flex-lg-row border-bottom p-3">
                        <span>
                          <span className="fa fa-plus"></span>
                          <span>
                            {helpersNumbers.toPersianNum(
                              process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE
                            )}
                            ٪ مالیات بر ارزش افزوده
                          </span>
                        </span>
                        <span>
                          <span className="number-finance pl-2">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                Math.floor(
                                  (amount *
                                    parseInt(
                                      process.env
                                        .REACT_APP_TAX_PERCENT_AMOUNT_CHARGE
                                    )) /
                                    100
                                )
                              )
                            )}
                          </span>
                          <span>تومان</span>
                        </span>
                      </div>

                      <div className="d-flex flex-column align-items-center justify-content-between border-bottom flex-lg-row bg-light p-3">
                        <span>مبلغ قابل پرداخت</span>
                        <span className="d-flex flex-column">
                          <span className="text-left">
                            <span className="number-finance pl-2">
                              {helpersNumbers.toPersianNum(
                                helpersNumbers.toFormatFinanceNumber(
                                  finalAmount
                                )
                              )}
                            </span>
                            <span>تومان</span>
                          </span>
                          <span>(معادل {finalAmountText} تومان)</span>
                        </span>
                      </div>
                    </div>

                    <div className="text-left pt-3">
                      <ButtonDisable
                        buttonTagHtml={
                          <span className="btn btn-success opacity-50">
                            <span className="pl-2">
                              <i className="fa fa-credit-card"></i>
                            </span>
                            <span>پرداخت</span>
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Charge;
